import * as React from 'react';

// temporary while we don't have numeric inputs
import { Input } from 'components/antd';
import classNames from 'classnames';

import stylesInput from '../Input/Input.module.scss';
import styles from './InputNumber.module.scss';

import { InputProps } from 'antd/lib/input/Input';

export class InputNumberSimple extends React.Component<InputProps> {
	elem: Input | null;

	constructor(props: InputProps) {
		super(props);
		this.elem = null;
	}

	focus() {
		if (this.elem) {
			this.elem.focus();
		}
	}

	render() {
		const { className, ...restProps } = this.props;
		return (
			<Input
				className={classNames(stylesInput.input, styles.inputNumber, className)}
				ref={elem => (this.elem = elem)}
				{...restProps}
			/>
		);
	}
}

export default InputNumberSimple;
